import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    if (pw !== pw2) { setErr("Passwörter stimmen nicht überein"); return; }
    if (pw.length < 6) { setErr("Mindestens 6 Zeichen"); return; }
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (e) {
      setErr(formatApiError(e));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-sm p-6">
        <h2 className="text-xl font-semibold tracking-tight text-slate-900">Neues Passwort festlegen</h2>
        {!token && <p className="text-rose-700 text-sm mt-2">Kein gültiges Token in der URL.</p>}
        {done ? (
          <p className="text-emerald-700 text-sm mt-4">Passwort wurde aktualisiert. Weiterleitung...</p>
        ) : token ? (
          <form onSubmit={submit} className="space-y-3 mt-4">
            <div>
              <Label className="text-xs text-slate-700">Neues Passwort</Label>
              <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1" data-testid="reset-pw" />
            </div>
            <div>
              <Label className="text-xs text-slate-700">Wiederholen</Label>
              <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1" data-testid="reset-pw2" />
            </div>
            {err && <div className="text-sm bg-rose-50 border border-rose-200 text-rose-800 px-3 py-2 rounded-sm">{err}</div>}
            <Button type="submit" className="w-full bg-slate-900 hover:bg-slate-800" data-testid="reset-submit">Passwort setzen</Button>
            <Link to="/login" className="text-xs text-slate-600 hover:text-slate-900 block text-center pt-1">Zur Anmeldung</Link>
          </form>
        ) : null}
      </div>
    </div>
  );
}
